<template>
  <div class="orders-page page">
    <div class="page-header page-header-left page-header-flex">
      <div>
        <h1 class="title">Orders</h1>
        <p class="subtitle">
          Review your most recent orders. Keep in mind that sometimes it takes awhile to process them - just be patient!
        </p>
      </div>
      <div>
        <div class="title-hero">
          <img src="../assets/img/orders-hero.svg"/>
        </div>
      </div>
    </div>
    
    <el-row :gutter="20">
      <el-col>
        <el-table
          :data="orders"
          :show-header="orders.length > 0"
          class="card-table"
          v-loading="ordersLoading">
          
          <template slot="empty">
            It looks like you haven't been awarded or spent any gold.
          </template>

          <el-table-column label="Status" width="313px">
            <template slot-scope="scope">
              <div class="order-status">
                <el-progress
                  :percentage="scope.row.progress <= scope.row.amount ? (scope.row.progress / scope.row.amount) * 100 : 100"
                  :show-text="false"
                  :status="getProgressStatus(scope.row)"
                >
                </el-progress>
                <div class="order-status-text">
                  <div class="is-left uppercase dark-text">
                    {{ scope.row.status }}
                  </div>
                  <div class="is-right grey-text">
                    {{ scope.row.progress }} of {{ scope.row.amount }} left
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="Progress" width="150px">
            <template slot-scope="scope">
              <div class="order-progress">
                <span class="icon">
                  <img src="../assets/img/heart.svg"/>
                </span>
                <span class="order-progress-text">
                  {{ scope.row.progress }}
                </span>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="created_at" label="Created">
            <template slot-scope="scope">
              <div class="order-created">
                {{scope.row.created_at | formatDate('MMM D, hh:mm') }}
              </div>
            </template>
          </el-table-column>
          
          <el-table-column prop="updated_at" label="Updated">
            <template slot-scope="scope">
              <div class="order-updated">
                {{scope.row.updated_at | formatDate('MMM D, hh:mm') }}
              </div>
            </template>
          </el-table-column>

          <!-- disabled for now -->
          <el-table-column v-if="1 === 2">
            <template>
              <div class="is-right order-menu">
                <a
                  href="#"
                  class="btn-menu"
                >
                  <span class="dot"></span>
                  <span class="dot"></span>
                  <span class="dot"></span>  
                </a>
              </div>
            </template>
          </el-table-column>

        </el-table>

      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'orders',
  data () {
    return {}
  },
  created () {
    this.fetchOrders();
  },
  computed: {
    ...mapGetters([
      'orders',
      'ordersLoading',
    ])
  },
  methods: {
    ...mapActions([
      'fetchOrders'
    ]),
    getProgressStatus(order) {
      if (order.status === 'Failed') {
        return 'exception';
      }
      
      if (order.progress < order.amount) {
        return 'warning';
      }

      return 'success';
    }
  },
}
</script>

<style lang="scss" scoped>
.page-header {
  margin-top: -34px;
}

.order-status {
  width: 202px;

  .el-progress {
    margin-bottom: 4px;
  }

  .order-status-text {
    display: flex;
    justify-content: space-between;
  }
}

.order-progress {
  color: #E77472;
  
  .icon {
    display: inline-block;
    margin-right: 5px;
    width: 19px;
    height: 19px;
    vertical-align: middle;
  }

  .order-progress-text {
    display: inline-block;
    vertical-align: middle;
  }
}

::v-deep .el-progress-bar__outer {
  height: 12px !important;
}
</style>
